<template>
  <div class="match-results">
    <div
      class="match-result-standard text-center"
      v-if="!isTennis">
      <div class="left color-important">
        {{ matchStatus.result }}
      </div>
      <div class="right color-faded">
        {{ resultPeriod }}
      </div>
    </div>
    <div
      class="match-result-tennis text-center"
      v-else-if="isTennis">
      <div class="period-points color-important">
        {{ matchStatus.gameScore }}
      </div>
      <div
        class="period color-faded"
        :class="{ 'color-normal': resultPeriod.length === index }"
        v-for="index in resultPeriod.length"
        :key="index">
        <p
          class="period-home"
          :class="{ 'color-normal': resultPeriod[index-1][0] > resultPeriod[index-1][1] }">
          {{ resultPeriod[index-1][0] }}
        </p>
        <p
          class="period-away"
          :class="{ 'color-normal': resultPeriod[index-1][0] < resultPeriod[index-1][1] }">
          {{ resultPeriod[index-1][1] }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { map, first, last } from 'lodash';
import { sport } from '@/services/mixins';

export default {
  name: 'MatchResults',
  mixins: [sport],
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
  },
  computed: {
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    resultPeriod() {
      if (!first(this.matchStatus.resultDetails)) {
        return this.idSport === 5 ? [] : this.matchStatus.result;
      }

      let period;
      switch (this.idSport) {
        case 1:
        case 6:
          // Soccer, Handball
          period = first(this.matchStatus.resultDetails).score;
          break;
        case 5:
          // Tennis
          period = map(this.matchStatus.resultDetails, (result) => {
            const score = result.score.split(':');

            return score.length > 0 ? [score[0], score[1]] : [];
          });
          break;
        default:
          period = last(this.matchStatus.resultDetails).score;
      }

      return period;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-results {
  height: 100%;
  font-size: 0.875rem;
  font-weight: $font-weight-bold;
}

.match-result-standard {
  height: 100%;

  .left,
  .right {
    float: left;
    width: 50%;
  }
}

.match-result-tennis {
  position: relative;
  height: 100%;

  .period {
    float: right;
    width: 20%;
    height: 100%;
    .period-home,
    .period-away {
      float: left;
      width: 100%;
      height: 50%;
      line-height: 2.5vh;
      font-size: 0.625rem;
    }
  }

  .period-points {
    position: absolute;
    top: 0;
    left: -$match-points-width;
    bottom: 0;
    width: $match-points-width;
  }
}
</style>
